import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../global/Layout';

export default function UnauthorizedPage() {
  const message = "You don’t have permission to access this page.";

  return (
    <Layout>
      <main className="rs-main">
        <section className="rs-card rs-card--error">
          <div className="rs-error__icon" aria-hidden>
            <svg
              viewBox="0 0 48 48"
              className="rs-error__svg"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="10"
                y="20"
                width="28"
                height="20"
                rx="3"
                ry="3"
                className="rs-error__ring"
              />
              <path
                d="M16 20v-6a8 8 0 0 1 16 0v6"
                className="rs-error__line"
                fill="none"
              />
              <circle cx="24" cy="30" r="2.5" className="rs-error__dot" />
            </svg>
          </div>

          <div className="rs-error__meta">
            <h1 className="rs-error__title">403 — Unauthorized</h1>
            <p className="rs-error__subtitle">{message}</p>

            <div className="rs-error__actions">
              <Link to="/" className="rs-btn rs-btn--primary">
                <span className="rs-btn__icon">🏠</span>
                Home
              </Link>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
}
